import { createAction } from '@reduxjs/toolkit'
import { CommentaryEntityContext } from '@helios/common-api'

/**
 * Opens the comments drawer with the given entity context and action mode,
 * optionally narrowed to a set of thread ids.
 */
export const openCommentaryDrawer = createAction<{
  entityContext: CommentaryEntityContext | null
  commentaryAction: 'view' | 'add' | null
  /** thread ids from a Commentary widget click or a comment deep link. Absent on every other open path. */
  threadIds?: string[]
  /** the specific comment to jump to, from a comment deep link. Absent on every other open path. */
  commentId?: string
}>('[Commentary] Open Drawer')
